<div class="tw-flex tw-items-center tw-flex-wrap tw-gap-2">
  <button class="tw-bg-pinkDark tw-text-white tw-px-3 tw-py-1" (click)="clearAllFilters()" *ngIf="queryParams && queryParams.length">Clear All</button>
  <button  class="tw-bg-grayLight tw-px-2" *ngFor="let param of queryParams;" (click)="removeFilter(param)">
    {{param?.data}}
    <span class="closebtn">&times;</span>
  </button>
</div>